import { type Common } from '../common.js';
import { type ChatSessionPopulatedWithVoiceCall } from '../models/assistant/chat.js';
import { SortOrder } from '../models/common.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/voice-calls';
  }

  async getVoiceCall(
    voiceCallId: string,
    args?: {
      orderBy?: string;
      orderByDirection?: SortOrder;
    }
  ): Promise<ChatSessionPopulatedWithVoiceCall> {
    const { orderBy = 'created', orderByDirection = SortOrder.Ascending } = args ?? {};
    const url = this.common.constructPath(`${this.baseEndpoint}/${voiceCallId}`, {
      orderBy,
      orderByDirection,
    });
    return await this.common.getJSON(url);
  }
}
